import {
  Component,
  effect,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router, Event, RouterModule } from '@angular/router';
import { LoginComponent } from '@components/login/login.component';
import {
  AuthService,
  DatasetService,
  MediaService,
  NotificationService,
} from '@services';
import { Subscription, filter, map } from 'rxjs';
import { environment } from '@environment';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  imports: [
    RouterModule,
    CommonModule,

    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatDividerModule,
  ],
})
export class SidenavComponent implements OnInit {
  private router = inject(Router);

  geologicalSampleDatasetId = environment.geologicalSampleDatasetId;
  mapArchiveId = environment.mapArchiveDatasetId;
  vesselDatasetId = environment.vesselDatasetId;
  dialog = inject(MatDialog);
  datasetService = inject(DatasetService);
  notificationService = inject(NotificationService);
  authService = inject(AuthService);
  currentRoute = signal('/');
  isAccountMenuOpen = signal(false);
  media = inject(MediaService);

  sidenav = input.required<MatSidenav>();

  isLinksExpanded = signal(false);
  isArchivesExpanded = signal(false);
  isPlacenamesExpanded = signal(false);
  isAdminExpanded = signal(false);
  isResourcesExpanded = signal(false);
  isPlanktonExpanded = signal(false);
  isGeodataExpanded = signal(false);

  private subscriptions: Subscription[];

  constructor() {
    this.subscriptions = [];

    effect(() => {
      const route = this.currentRoute();

      if (route.startsWith('/geodata/api')) {
        this.isResourcesExpanded.set(true);
      } else if (route.startsWith('/geodata')) {
        this.isGeodataExpanded.set(true);
      } else if (
        route.startsWith('/geology') ||
        route.startsWith('/map') ||
        route.startsWith('/vessel')
      ) {
        this.isArchivesExpanded.set(true);
      } else if (route.startsWith('/placename') || route.startsWith('/case')) {
        this.isPlacenamesExpanded.set(true);
      } else if (
        route.startsWith('/label') ||
        route.startsWith('/role') ||
        route.startsWith('/token') ||
        route.startsWith('/user')
      ) {
        this.isAdminExpanded.set(true);
      } else if (route.startsWith('/plankton')) {
        this.isPlanktonExpanded.set(true);
      }
    });
  }

  ngOnInit() {
    const urlSubscription = this.router.events
      .pipe(
        filter((e: Event) => e instanceof NavigationEnd),
        map((e: Event) => {
          return (e as NavigationEnd).url;
        }),
      )
      .subscribe((url: string) => {
        this.currentRoute.set(url);
        if (!this.media.landscape()) {
          this.sidenav().close();
        }
      });

    this.subscriptions.push(urlSubscription);
  }

  parseAccessLevel(accessLevel: string): string {
    switch (accessLevel) {
      case 'admin':
        return 'Administrator';
      case 'internal':
        return 'Internal';
      default:
        return 'External';
    }
  }

  openLoginDialog() {
    this.dialog.open(LoginComponent, {
      minWidth: '360px',
      width: '480px',
    });
  }

  isActive(...values: string[]): boolean {
    for (const value of values) {
      if (this.currentRoute().startsWith(value)) {
        return true;
      }
    }

    return false;
  }
}
